module.exports = __webpack_public_path__ + "img/Warning.93237362.svg";